module.exports = __webpack_public_path__ + "static/media/arrow2.fd592402.jpg";